import { Text } from '@applane/react-core-components';
import Toast from '@applane/react-toast';
import React, { useEffect, useState } from 'react';
import { Form } from '../../../app-components/form/Form';
import { invoke } from '../../../AppServices';
import vars from '../../../theme/vars';

export const SASetting = (props) => {
  const { navigation } = props;

  const settingUri = () => ({
    query: {
      model: 'Setting',
      id: 'settingDataQuerySA',
      relationValue: {
        model: 'Setting',
        _id: navigation?.state?.params?.item?._id,
        relation: '_id',
      },
      limit: 1,
    },
    model: 'Setting',
  });

  return (
    <Form
      type="standard"
      onSubmit={async ({ data }) => {
        console.log('setting page on submit showing data->', data);
        // let obj = {
        //   repairOrderTime:data.repairOrderTime,
        //   regularTime: data.regularTime,
        //   appraiseTime: data.appraiseTime,

        // }
        await invoke({
          id: 'updateSettingsSA',
          paramValue: { data },
        });
        Toast.show({
          message: 'Success',
          description: 'Settings Saved.',
          type: 'success',
          position: 'top',
          direction: 'right',
          duration: 3000,
        });
      }}
      uri={settingUri}
      mandatory={{
        repairOrderTime: 1,
        regularTime: 1,
        autoAppraise: 1,
        appraiseTime: 1,
      }}
      fieldContainer="topLabel"
      validations={{
        repairOrderTime: ({ data }) => {
          console.log('validation ro time...', data);
          if (!data?.repairOrderTime) {
            return;
          }

          if (/^\d+\.?\d*$/.test(data?.repairOrderTime)) {
            const number = parseInt(data?.repairOrderTime);
            if (number === 0 || number > 59) {
              return 'Invalid';
            }
          } else {
            return 'This must be a number.';
          }
        },
        regularTime: ({ data }) => {
          if (!data?.regularTime) {
            return;
          }

          if (/^\d+\.?\d*$/.test(data?.regularTime)) {
            const number = parseInt(data?.regularTime);
            if (number === 0 || number > 59) {
              return 'Invalid';
            }
          } else {
            return 'This must be a number.';
          }
        },

        appraiseTime: ({ data }) => {
          if (!data?.appraiseTime) {
            return;
          }

          if (/^\d+\.?\d*$/.test(data?.appraiseTime)) {
            const number = parseInt(data?.appraiseTime);
            if (number === 0 || number > 59) {
              return 'Invalid';
            }
          } else {
            return 'This must be a number.';
          }
        },
      }}
      lg={{
        formGroups: [
          //RO , SALE stuff...
          {
            columnsPerRow: 4,
            fieldVariant: 'filled',
            label: 'Cron Scheduling',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid ${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: [
                  {
                    label: 'Repair Order (Minutes)',
                    field: 'repairOrderTime',
                    editable: true,
                    type: 'text',
                  },
                  {
                    label: 'Regular (Minutes)',
                    field: 'regularTime',
                    editable: true,
                    type: 'text',
                    visible: false,
                  },
                ],
              },
            ],
          },

          //appraisal related
          {
            columnsPerRow: 1,
            fieldVariant: 'filled',
            label: 'Appraisal',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid ${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: [
                  // {
                  //   label: 'Auto Appraise',
                  //   field: 'autoAppraise',
                  //   type: 'checkBox',
                  //   editable: true,
                  // },
                  {
                    label: 'Appraise Interval (Minutes)',
                    field: 'appraiseTime',
                    editable: true,
                    width: 300,
                    type: 'text',
                  },
                ],
              },
            ],
          },
        ],
      }}
      {...props}
    />
  );
};
